export default "/images/00df05f4daec9188ef94110f475131fb.avif";